import styled from '@emotion/styled';

export const Backdrop = styled.div`
 position: fixed;
 z-index: 1;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color:  ${props => props.theme.backgrounds.modalBackdrop};;
}
`;

export const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 600px;
  width: 100%;
  padding: 12px;
  background-color:  ${props => props.theme.backgrounds.modalBody};;
  border-radius: 3px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
`;
